import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorage } from 'ngx-store';

@Injectable({
  providedIn: 'root'
})
export class CondutorGuard implements CanActivate {
  @LocalStorage('usuario') usuario = null;

	constructor(public router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.usuario.usuario_perfil == 8) {
      this.router.navigate(['home/checklist']);
      return false;
    }
		return true;
  }
}
